import { reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import { CommonActions } from '@react-navigation/native';
import I18n from '../../../lib/i18n';
import { wrapComponentWith } from '../../../lib/hoc';
import Navigation from '../../../lib/navigation';
import BillingAddress from './BillingAddress.container';
import { GradientPage } from '../../../components/common';
import { billingAddressSelector, customerFullNameSelector } from '../../../modules/Customer/selectors';
import { confirmDeliveryAddress } from '../../../modules/SignUp/DeliveryAddress';
import config from '../../../config';
import validate from './validation';
import { setDeliveryContact } from '../../../modules/SignUp/DeliveryContact';
import { updateBillingAddressDuringProcess } from '../../../modules/BillingAddress';
import {
  eSimSelectedSelector,
} from '../../../modules/ESim/selectors';

const getInitialValues = state => {
  const initialValues = billingAddressSelector(state);
  if (config.askPersonalInformationDuringOrderSim) {
    return {
      ...initialValues,
      useSameAddressForDelivery: true,
      fullName: customerFullNameSelector(state),
    };
  }

  return initialValues;
};

const mapStateToProps = state => ({
  initialValues: getInitialValues(state),
  postCode: formValueSelector('billingAddress')(state, 'postCode'),
  eSimSelected: eSimSelectedSelector(state),
});

const mapDispatchToProps = dispatch => ({
  changeFormField: (fieldName: string, fieldValue: string) => dispatch(change('billingAddress', fieldName, fieldValue)),
  onSubmit: values => {
    dispatch(setDeliveryContact({ name: values.fullName }));
    dispatch(updateBillingAddressDuringProcess(values));
    if (config.askPersonalInformationDuringOrderSim) {
      if (values.useSameAddressForDelivery) {
        dispatch(confirmDeliveryAddress(values));
      } else {
        Navigation.dispatch(CommonActions.navigate({ name: 'deliveryAddress' }));
      }
    } else {
      Navigation.dispatch(CommonActions.navigate({ name: 'selfieCheck' }));
    }
  },
});

const withFlaggedProps = (): { title: string, displayCheckboxUseSameAddresses: boolean } => ({
  title: I18n.t('SignUp.BillingAddress.title'),
  displayCheckboxUseSameAddresses: config.askPersonalInformationDuringOrderSim,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withFlaggedProps),
  reduxForm({ form: 'billingAddress', validate }),
  wrapComponentWith(GradientPage)
);
export default enhance(BillingAddress);
